export const MALTE_ASSETS = 'malte'
export const INTEGREAT_ASSETS = 'integreat'
export const ASCHAFFENBURG_ASSETS = 'aschaffenburg'
export const OBDACH_ASSETS = 'obdach'
